import { render, staticRenderFns } from "./SidebarForm.vue?vue&type=template&id=224f39db&scoped=true&"
import script from "./SidebarForm.vue?vue&type=script&lang=js&"
export * from "./SidebarForm.vue?vue&type=script&lang=js&"
import style0 from "./SidebarForm.vue?vue&type=style&index=0&id=224f39db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f39db",
  null
  
)

export default component.exports